import request from '@/router/axios';
let urlPrefix = '/api/shenbao//shenbaoexpuserkpoint'

export const getKnowByQuery = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit,
        }
    })
}

export const getKnowByApi = (shenbaoExpId ,shenbaoUserId ) => {
    return request(`${urlPrefix}/${shenbaoExpId}/${shenbaoUserId}/list`)
}